<template>
  <div class="profile-form">
    <div class="profile-form__head">
      <img :src="`/img/${config.image}.svg`" :alt="config.image" />
      <p>
        {{ _T(config.title) }}
      </p>
      <button
        v-if="!isEdited"
        type="button"
        class="profile-form__edit"
        @click.prevent="onEdit"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 21L12 21H21"
            stroke="#2B2B2B"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12.2218 5.8279L15.0503 2.99947L20 7.94922L17.1716 10.7776M12.2218 5.8279L6.61522 11.4345C6.42769 11.622 6.32233 11.8764 6.32233 12.1416L6.32233 16.6771L10.8579 16.6771C11.1231 16.6771 11.3774 16.5718 11.565 16.3842L17.1716 10.7776M12.2218 5.8279L17.1716 10.7776"
            stroke="#2B2B2B"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>
    <div class="profile-form__body">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useAppearanceStore } from "~/store/appearanceStore.js";

type ProfileSectionConfig = {
  name: "customer" | "contacts" | "password";
  title: string;
  image: string;
};

interface Props {
  config: ProfileSectionConfig;
}

const props = defineProps<Props>();

const appearanceStore = useAppearanceStore();
const { account } = storeToRefs(appearanceStore);

const isEdited = computed(() => account.value[props.config.name].isEdited);

const onEdit = () => {
  account.value[props.config.name].isEdited = true;
};
</script>

<style lang="scss" scoped>
.profile-form {
  width: 100%;

  @include flex-container(column, center, flex-start);
  gap: 16px;

  border-bottom: 1px solid #f3f3f3;

  padding: 24px;

  @include bigMobile {
    padding: 16px 0;
  }

  &__head {
    @include flex-container(row, flex-start, center);
    gap: 16px;

    @include font(18, 24, 500);

    @include bigMobile {
      @include font(16, 22, 500);
    }
  }

  &__edit {
    @include fixedHW(34px, 34px);

    @include flex-container(row, center, center);

    path {
      transition: stroke 0.2s;
    }

    &:hover {
      svg path {
        stroke: var(--color-primary-base);
      }
    }
  }

  &__body {
    width: 100%;

    padding-left: 40px;

    @include bigMobile {
      padding-left: 0;
    }
  }
}
</style>
